export const calculateTotalLOS = (bookingList) => {
  const totalDays = bookingList.reduce(
    (sum, booking) => sum + booking.totaldays,
    0
  );
  const totalBookings = bookingList.length;
  return totalBookings > 0 ? (totalDays / totalBookings).toFixed(2) : 0;
};
